export default "__VITE_ASSET__DUo6mqCH__"